const VariationStatusConstants = {
    DRAFT: 0,
    PROPOSED: 1,
    APPROVED: 2,
    REJECTED: 3,
    CLOSED: 4
}

export default VariationStatusConstants